import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import MedicationService from '../../../../services/medication-service';
import { Endpoint } from '../../../../../../constants/endpoints';

export interface EmarRecords {
  attributeId?: string;
  attributeName: string;
  value: string;
}

export interface ConsistEmarRecordsRequest {
  encounterId: string
  records: EmarRecords[]
  scheduleId: number
  type: number
  vitalSingDate?: string
}

export default class ExecuteNursingInterventionsService {

  public static execute(body: Record<string, Value>): Promise<void> {
    return HttpService.post<{ messageDescription: string; }>(Endpoint.ADEP_EXECUTE_NURSING_INTERVENTIONS, {}, { body })
      .then((response) => {
        const responseBody = response.body;
        if (responseBody?.messageDescription) {
          MedicationService.showToast(responseBody?.messageDescription, ToastLevel.WARNING);
          return;
        }
        MedicationService.showToast(MessageService.translate('text.perform-with-success'), ToastLevel.SUCCESS);
      }).catch((error) => {
        if (error.body && error.body.errors) {
          error.body.errors.forEach((message: string) => MedicationService.showToast(MessageService.translate(message), ToastLevel.ERROR));
        }
      });
  }

  public static executeWithoutMessages(body: Record<string, Value>): Promise<void> {
    return HttpService.post<void>(Endpoint.ADEP_EXECUTE_NURSING_INTERVENTIONS, {}, { body })
      .then((response) => {
        const responseBody = response.body;
        return responseBody
      })
      .catch((error) => {
        if (error.body && error.body.errors) {
          error.body.errors.forEach((message: string) => MedicationService.showToast(MessageService.translate(message), ToastLevel.ERROR));
        }
      });
  }

  public static consistEmarRecords(body: ConsistEmarRecordsRequest): Promise<void> {
    return HttpService.post<void>(Endpoint.ADEP_CONSIST_EMAR_RECORDS, {}, { body: body as unknown as Record<string, Value> })
      .then(() => {
        MedicationService.showToast(MessageService.translate('text.perform-with-success'), ToastLevel.SUCCESS);
      }).catch((error) => {
        if (error.body && error.body.errors) {
          error.body.errors.forEach((message: string) => MedicationService.showToast(MessageService.translate(message), ToastLevel.ERROR));
        }
      });
  }
}